// extracted by mini-css-extract-plugin
export default {"terrazzo":"Terrazzo_terrazzo__Iz4Co"};